module.exports = require('react/lib/shallowCompare');


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/react-event-listener/~/react-addons-shallow-compare/index.js
// module id = 711
// module chunks = 0